// extracted by mini-css-extract-plugin
module.exports = {"intro":"Intro_intro__1nDLm","content":"Intro_content__12y2K","fadeInBack":"Intro_fadeInBack__2aCZm"};